var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.51062 12.6197C2.44161 12.4123 2.44161 12.1881 2.51062 11.9807C3.89762 7.80773 7.83462 4.79773 12.4746 4.79773C17.1126 4.79773 21.0476 7.80473 22.4376 11.9757C22.5076 12.1827 22.5076 12.4067 22.4376 12.6147C21.0516 16.7877 17.1146 19.7977 12.4746 19.7977C7.83662 19.7977 3.90162 16.7907 2.51162 12.6197H2.51062Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4746 12.2977C15.4746 13.0934 15.1585 13.8564 14.5959 14.4191C14.0333 14.9817 13.2703 15.2977 12.4746 15.2977C11.679 15.2977 10.9159 14.9817 10.3533 14.4191C9.79068 13.8564 9.47461 13.0934 9.47461 12.2977C9.47461 11.5021 9.79068 10.739 10.3533 10.1764C10.9159 9.6138 11.679 9.29773 12.4746 9.29773C13.2703 9.29773 14.0333 9.6138 14.5959 10.1764C15.1585 10.739 15.4746 11.5021 15.4746 12.2977V12.2977Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.6f629a0bedf8204b06fd96449ba32629.svg";
export { ForwardRef as ReactComponent };